export default __webpack_public_path__ + "static/media/4.3c0c8771.jpg";